import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HelpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"help"}/>
}
